import React, { useEffect, useState } from "react";
import AutoIncrementLeaveDetails from "./AutoIncrementLeaveDetails";
import AddAutoIncrementLeaveBalance from "./AddAutoIncrementLeaveBalance";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";

const ALL_MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

const LeaveBalanceAutoIncrementList = ({ selectedLeaveType, selectedYear }) => {
  const axiosPrivate = useAxiosPrivate();

  const [details, setDetails] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const getPreviousMonthAndYear = () => {
    const today = new Date();
    let month = today.getMonth(); // 0-based
    let year = selectedYear;

    if (month === 0) {
      month = 12;
      year = selectedYear - 1;
    }

    return { month, year };
  };

  const fetchDetails = async () => {
    try {
      if (!selectedLeaveType.id) return;

      const { month, year } = getPreviousMonthAndYear();

      const response = await axiosPrivate.get(
        `lms/leave/viewDetailsAutoIncrementLeaveBalance` +
          `?leave_type_id=${selectedLeaveType.id}` +
          `&year=${year}` 
      );

      const data = response?.data?.leaveTypeList || [];
      setDetails(data);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    fetchDetails();
  }, [selectedLeaveType, selectedYear]);

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  const getVisibleMonths = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonthIndex = today.getMonth(); 

    if (selectedYear < currentYear) {
      return ALL_MONTHS;
    }

    if (selectedYear === currentYear) {
      return ALL_MONTHS.slice(0, currentMonthIndex + 1); 
    }

    return [];
  };

  return (
    <div className="relative overflow-x-auto min-h-screen bg-white shadow-md rounded-lg">
      <table className="w-full text-sm text-left text-gray-500">
        <thead className="text-xs font-medium uppercase bg-gray-50 text-gray-700 border-b">
          <tr>
            <th className="px-6 py-3">Month</th>
            <th className="px-6 py-3">Year</th>
            <th className="px-6 py-3">Date</th>
            <th className="px-6 py-3">Time</th>
            <th className="px-6 py-3">Updated Type</th>
            <th className="px-6 py-3">Status</th>
            <th className="px-6 py-3"></th>
          </tr>
        </thead>

        <tbody className="bg-white divide-y divide-gray-200">
          <AutoIncrementLeaveDetails
            details={details}
            months={getVisibleMonths()}
            selectedYear={selectedYear}
            leaveTypeId={selectedLeaveType.id}
            leaveTypeName={selectedLeaveType.name}
            refreshDetails={fetchDetails}
          />
        </tbody>
      </table>

      {isModalOpen && (
        <AddAutoIncrementLeaveBalance
          open={isModalOpen}
          close={toggleModal}
          leaveTypeId={selectedLeaveType.id}
          leaveTypeName={selectedLeaveType.name}
          refreshDetails={fetchDetails}
        />
      )}
    </div>
  );
};

export default LeaveBalanceAutoIncrementList;
